import PickerList from "components/Picker/PickerList";
import React from "react";
import { formatWrittenDayMonthYear } from "utilities";
import { joinWithMaxLength } from "utilities/stringutils";
import moment from "moment";
import SubLabel from "components/Atoms/Sublabel";
import { PickerListProps } from "../props";

const ProductionList = (props: PickerListProps<server.dto.ProductionSmallV2>) => {
  const [instruction, setInstruction] = React.useState<server.dto.ListProductionInstruction>({
    excludeKeys: props.excludeKeys,
    page: 1,
    perPage: 20,
    keyword: "",
  });

  return <>
    <PickerList
      instruction={instruction}
      onInstructionChange={setInstruction}
      queryKey="productionlist"
      api={window.CoreApi.Production.PaginatedSmall}
      onItemSelected={props.onItemSelected}
      getError={() => undefined}
      excludeKeys={props.excludeKeys}
      getId={production => production.productionId}
      renderListItem={production => <>
        <div>{production.name}</div>
        <ProductionSublabel production={production} />
      </>}
    />
  </>;
};

export const ProductionSublabel = (props: { production: server.dto.ProductionSmallV2 }) => {
  if (props.production.startDate == null) return null;

  const startDate = moment.utc(props.production.startDate);
  const endDate = moment.utc(props.production.endDate);

  const maxArtistsToShow = 2;

  return <>
    <SubLabel small>{formatWrittenDayMonthYear(startDate)} - {formatWrittenDayMonthYear(endDate)}</SubLabel>
    <SubLabel small>{joinWithMaxLength(props.production.artists, ", ", maxArtistsToShow)}</SubLabel>
  </>;
}


export default ProductionList;